/*eslint-disable  */
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { OAuth2 } from 'jsforce';

import { getSalesforceToken, parseToken, TokenData } from '../utils/Helpers/DupontSalesforceService';
import { DupontLogger } from '../utils';
import { setRequestHeaders } from 'services/api.service';
//import { postDataToParent } from 'utils/helper';

interface Props {
  children?: ReactNode;
  onAuthentication?: Function;
  loginUrl?: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
}

const useSalesforceSSO = (initOptions: Props) => {
  const Logger = DupontLogger('useSalesforceSSO');
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [tokenData, setTokenData] = useState<TokenData | undefined>(undefined);
  const [refreshInterval, setRefreshInterval] = useState<number | undefined>();

  async function refreshToken(refresh_token: string) {
    const { clientId, clientSecret } = initOptions;
    const getRefreshTokenParam = {
      client_id: clientId,
      client_secret: clientSecret,
      refresh_token,
      grant_type: 'refresh_token',
    };
    Logger.log('refreshToken - Token Expiry time in one minutes: ', getRefreshTokenParam);
    //await getSalesforceToken(getRefreshTokenParam);
  }

  const getAuthTokens = async (grant_type: string) => {
    Logger.log('Salesforce - getAuthTokens: ', grant_type);
    const data = await getSalesforceToken({ ...initOptions, grant_type });
    if (data) {
      setTokenData(data);
      setRequestHeaders({ authorization: 'Bearer ' + data.authToken });
      setRefreshInterval(data?.refreshInterval);
    }
    setIsAuthenticating(false);
  };

  useEffect(() => {
    if (refreshInterval && tokenData) {
      setTimeout(() => refreshToken(tokenData?.refreshToken), refreshInterval);
    }
  }, [refreshInterval]);

  const initSSO = () => {
    Logger.log('Salesforce - Initaiting SSO');
    try {
      if (!window.location.search.includes('code=')) {
        const oAuth2 = new OAuth2(initOptions);
        const redirectUrl = oAuth2.getAuthorizationUrl({});
        window.location.href = redirectUrl;
      } else {
        Logger.log('Salesforce - initSSO, code not present ');
        getAuthTokens('authorization_code');
      }
    } catch (err) {
      Logger.error('initSSO - error: ', err);
      setIsAuthenticating(false);
    }
  };

  const initSSOAuth = () => {
    setIsAuthenticating(true);
    const token = process.env.REACT_APP_AUTH_TOKEN;
    if (token) {
      const data = parseToken(token);
      setTokenData(data);
      setIsAuthenticating(false);
    } else {
      initSSO();
      // if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
      //   initSSO();
      // } else {
      //   const value = { ssoAction: 'LOGIN' };
      //   postDataToParent(value);
      //   sessionStorage.setItem('isUserLoggedin', 'false');
      // }
    }
  };

  // useEffect(() => {
  //   Logger.log('Salesforce useSalesforceSSO - initaiting Authentication ');
  //   initSSOAuth();
  // }, []);

  return { isAuthenticating, tokenData, getAuthTokens, initSSOAuth };
};

export default useSalesforceSSO;
